import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Accordion } from "react-bootstrap";

export function PricingFAQ() {
  return (
    <div className="container py-5 mb-5">
      <h2 className="text-center fw-bold mb-5 mt-4">FAQ : Questions fréquentes freemium </h2>
      <Accordion defaultActiveKey="0" flush className="accordion" style={{
        "--bs-accordion-btn-bg": "#f4fbf7",
        "--bs-accordion-btn-color": "#065f46",
        "--bs-accordion-active-bg": "#e8f7ef",
        "--bs-accordion-active-color": "#064e3b",
        "--bs-accordion-border-color": "#d1e7dd",
        "--bs-accordion-icon-color": "#198754",
        "--bs-accordion-icon-active-color": "#198754",
        "--bs-accordion-btn-focus-box-shadow": "0 0 0 .25rem rgba(25,135,84,.15)",
      }}>
        <Accordion.Item eventKey="0">
          <Accordion.Header className="custom-green" >
            Qu’est-ce que le modèle Freemium d’Agrospace ?
          </Accordion.Header>
          <Accordion.Body>
            Le modèle Freemium permet aux utilisateurs d’accéder gratuitement aux applications principales d’Agrospace avec un espace de travail basique, idéal pour tester la plateforme ou pour les petits exploitants.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>
            Quelles sont les limites du modèle Freemium ?
          </Accordion.Header>
          <Accordion.Body>
            <ul class="list-group list-group-flush">
              <li class="list-group-item"> Gestion limitée des exploitations (données et fonctionnalités réduites) </li>
              <li class="list-group-item"> Visibilité limitée sur le marché virtuel </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>
           Quels services sont inclus dans le Freemium ?
          </Accordion.Header>
          <Accordion.Body>
           <ul class="list-group list-group-flush">
              <li class="list-group-item"> Accès aux applications principales : Jaari Chatbot, Agriteam et Farm Space </li>
              <li class="list-group-item"> Réseau social et collaboration pour partager expériences et informations avec d’autres acteurs agricoles </li>
              <li class="list-group-item"> Création et gestion de compte avec validation par SMS </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>
            Puis-je passer à Premium ou Premium Pro depuis le Freemium ?
          </Accordion.Header>
          <Accordion.Body>
           Oui. Les utilisateurs Freemium peuvent facilement passer à Premium ou Premium Pro pour bénéficier de fonctionnalités avancées, telles que :
            <ul class="list-group">
              <li class="list-group-item">
                Gestion avancée des exploitations
              </li>
              <li class="list-group-item">
               Système multilingue pour le chatbot
              </li>
              <li class="list-group-item">
                Visibilité accrue et prioritaire sur le marché virtuel
              </li>
               <li class="list-group-item">
                Support prioritaire et ressources exclusives (Premium Pro)
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>
           Combien de temps puis-je utiliser le Freemium ?
          </Accordion.Header>
          <Accordion.Body>
            Le modèle Freemium est gratuit et sans limite de durée pour les utilisateurs souhaitant un environnement de travail basique.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>
           Est-ce que les données du Freemium peuvent être utilisées dans Premium ?
          </Accordion.Header>
          <Accordion.Body>
            Oui. Toutes les données et configurations du compte Freemium peuvent être migrées vers Premium ou Premium Pro afin de continuer à gérer vos exploitations et vos interactions sans perte d’informations.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}




export function SupportFAQ() 
{
  return (
    <div className="container py-5 mb-5">
      <div className="d-flex flex-column mb-4">
        <h3 className="">FAQ – Comprendre Agrospace et ses applications </h3>
        <p className="text-muted lead"> Votre aide et support pour naviguer facilement dans nos applications. </p>
      </div>
      <Accordion defaultActiveKey="0" flush className="accordion" style={{
        "--bs-accordion-btn-bg": "#f4fbf7",
        "--bs-accordion-btn-color": "#065f46",
        "--bs-accordion-active-bg": "#e8f7ef",
        "--bs-accordion-active-color": "#064e3b",
        "--bs-accordion-border-color": "#d1e7dd",
        "--bs-accordion-icon-color": "#198754",
        "--bs-accordion-icon-active-color": "#198754",
        "--bs-accordion-btn-focus-box-shadow": "0 0 0 .25rem rgba(25,135,84,.15)",
      }}>
        <Accordion.Item eventKey="0">
          <Accordion.Header className="custom-green" >
            Qu’est-ce qu’Agrospace ?
          </Accordion.Header>
          <Accordion.Body>
            Agrospace est une plateforme intégrée qui regroupe plusieurs applications et outils numériques dédiés au secteur agricole. Elle permet d’accéder facilement à l’information, de gérer les exploitations de manière intelligente et de collaborer avec d’autres acteurs du domaine.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>
            Quelles sont les principales applications proposées par Agrospace ?
          </Accordion.Header>
          <Accordion.Body>
            <ul class="list-group">
              <li class="list-group-item">
                <strong>Jaari Chatbot :</strong> un assistant intelligent capable de répondre à vos questions, 
                de fournir des conseils agricoles personnalisés et de traduire en audio les réponses dans plusieurs langues locales.
              </li>
              <li class="list-group-item">
                <strong>Agriteam :</strong> un réseau social agricole pour partager des expériences, publier des communiqués, 
                échanger des opportunités et participer à des sessions de discussion.
              </li>
              <li class="list-group-item">
                <strong>Farm Space :</strong> un outil de monitoring pour collecter, visualiser et analyser en temps réel 
                les données sur les cultures, l’irrigation et les ressources.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>
            À qui s’adresse Agrospace ?
          </Accordion.Header>
          <Accordion.Body>
            La plateforme s’adresse aux agriculteurs, coopératives, instituts de recherche, organisations gouvernementales et à tout acteur souhaitant optimiser la gestion agricole et renforcer la collaboration dans le secteur.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>
           Comment Jaari Chatbot peut-il m’aider au quotidien ?
          </Accordion.Header>
          <Accordion.Body>
           Jaari Chatbot vous accompagne comme un assistant virtuel. Il répond à vos questions, vous fournit des recommandations sur vos cultures et traduit les informations en plusieurs langues locales pour faciliter la compréhension.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>
            Comment fonctionne le monitoring avec Farm Space ?
          </Accordion.Header>
          <Accordion.Body>
            Farm Space permet de suivre vos parcelles grâce à la collecte et à l’analyse de données en temps réel (irrigation, climat, ressources, etc.). Ces informations sont traitées par notre modèle d’IA, et les actions peuvent être exécutées automatiquement par l’Edge-contrôleur.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>
            Que puis-je trouver dans Agriteam ?
          </Accordion.Header>
          <Accordion.Body>
            <p class="card-text">
              Dans <strong>Agriteam</strong>, vous accédez à un véritable réseau social agricole :
            </p>
            <ul class="list-group list-group-flush">
              <li class="list-group-item"> Partage d’expériences et de connaissances</li>
              <li class="list-group-item"> Diffusion de communiqués et d’informations importantes</li>
              <li class="list-group-item"> Opportunités de marché</li>
              <li class="list-group-item"> Création de communautés autour de thématiques agricoles</li>
              <li class="list-group-item"> Sessions de discussion collaboratives</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="6">
          <Accordion.Header>
            Le marché virtuel est-il sécurisé ?
          </Accordion.Header>
          <Accordion.Body>
            Oui. Toutes les transactions sont supervisées et sécurisées. Les commandes sont validées par notre équipe commerciale, qui vous accompagne pour le paiement et la livraison.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="7">
          <Accordion.Header>
            Comment obtenir l’Edge-contrôleur ?
          </Accordion.Header>
          <Accordion.Body>
            Vous pouvez passer commande directement via la plateforme. Une fois la demande soumise, notre équipe commerciale vous contactera pour finaliser les modalités de paiement et de livraison.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="8">
          <Accordion.Header>
            Agrospace est-il adapté aux petites exploitations ?
          </Accordion.Header>
          <Accordion.Body>
            Absolument. Que vous soyez un petit exploitant ou une grande coopérative, Agrospace propose des outils modulables adaptés à vos besoins.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="9">
          <Accordion.Header>
            Comment puis-je rejoindre la communauté Agrospace ?
          </Accordion.Header>
          <Accordion.Body>
            Il vous suffit de créer un compte sur la plateforme pour accéder à l’ensemble des applications et rejoindre la communauté Agrospace.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      
    </div>
  );
}
